import React from 'react';
import './Tooltip.css';

// Displays grouped tooltip data. Each group supplies a colour and an array of
// items that will be stacked vertically within that coloured section.
export function TooltipList({ groups = [], children }) {
  const formatAnswer = (a) => {
    if (typeof a === 'boolean') {
      return a ? 'Yes' : 'No';
    }
    if (a === undefined || a === null) {
      return '';
    }
    return String(a);
  };

  // Convert different item shapes into display text
  const normalise = (item) => {
    if (typeof item === 'string') {
      return item;
    }
    if (item && typeof item === 'object') {
      const q = item.question ?? Object.keys(item)[0];
      const aRaw = item.answer ?? item[q];
      return `${q}: ${formatAnswer(aRaw)}`;
    }
    return '';
  };

  return (
    <div className="tooltip-container">
      {children}
      <div className="tooltip-multi">
        {groups.map((grp, gIdx) => (
          <div
            key={gIdx}
            className="tooltip-group"
            style={{ backgroundColor: grp.color || '#c48e38' }}
          >
            {grp.items.map((item, iIdx) => (
              <p key={iIdx} className="tooltip-group-item">
                {normalise(item)}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
